/**
 * AccountSettingsSection - Edit profile and change password buttons
 */
import { Button } from "@/components/ui/button";
import { User, Pencil, Lock, ChevronRight } from "lucide-react";

const AccountSettingsSection = ({ userName, onEditProfile, onChangePassword }) => {
  return (
    <section className="bg-card rounded-2xl border border-charcoal/5 shadow-card overflow-hidden animate-fade-in">
      <div className="p-6 border-b border-charcoal/5">
        <div className="flex items-center gap-2 mb-1">
          <User className="w-5 h-5 text-primary" />
          <h2 className="font-serif text-xl font-medium text-charcoal">Account Settings</h2>
        </div>
        <p className="text-sm text-muted-foreground">
          Manage your profile and security
        </p>
      </div>
      <div className="p-6 space-y-3">
        <Button
          variant="outline"
          onClick={onEditProfile}
          className="w-full h-12 justify-start rounded-xl border-charcoal/10 hover:bg-primary/5"
          data-testid="edit-profile-section-btn"
        >
          <Pencil className="w-4 h-4 mr-3 text-primary" />
          <span className="flex-1 text-left">Edit Profile</span>
          <span className="text-sm text-muted-foreground">{userName}</span>
        </Button>
        
        <Button
          variant="outline"
          onClick={onChangePassword}
          className="w-full h-12 justify-start rounded-xl border-charcoal/10 hover:bg-primary/5"
          data-testid="change-password-btn"
        >
          <Lock className="w-4 h-4 mr-3 text-primary" />
          <span className="flex-1 text-left">Change Password</span>
          <ChevronRight className="w-4 h-4 text-muted-foreground" />
        </Button>
      </div>
    </section>
  );
};

export default AccountSettingsSection;
